import React, {useEffect, useState} from 'react';
import axiosInstance from "../../api";
import {Box, Paper} from "@material-ui/core";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AgentSearchCriteriaCreateTile from "./AgentSearchCriteriaCreateTile";
import AgentSearchCriteriaListViewTile from "./AgentSearchCriteriaListViewTile";
import {useUserContext} from "../../context/UserContext";
import AgentMappedRecordsListView from "./AgentMappedRecordsListView";
import AgentTaggedLeadsListView from "./AgentTaggedLeadsListView";
import AgentResolvedLeadsListView from "./AgentResolvedLeadsListView";
import AgentContactInfoView from "./AgentContactInfoView";
import {Link} from "@mui/material";

function AdminAgentDashboard({agentId,onReturnBack}) {
    const [tabValue, setTabValue] = React.useState(0);
    const {user,dispatch} = useUserContext();

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Box m={4}>
            <br/>
            <Box component="span" justifyContent="flex-start" marginLeft="16px" marginTop="8px"
                 alignItems="flex-end" display="flex">
                <Link onClick={() => onReturnBack()}>Back to User Search</Link>
            </Box>
            <br/>
            <Paper>
                <Box>
                    <Tabs
                        value={tabValue}
                        onChange={handleChange}
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                        aria-label="agent options"
                    >
                        <Tab label="Tagged Leads"/>
                        <Tab label="Matched Leads"/>
                        <Tab label="Resolved Leads"/>
                        <Tab label="Search Criteria"/>
                        <Tab label="Edit Profile"/>
                    </Tabs>
                </Box>
                {
                    tabValue === 0 && <AgentTaggedLeadsListView agentId={agentId} user={user}/>
                }
                {
                    tabValue === 1 && <AgentMappedRecordsListView  agentId={agentId} />
                }
                {
                    tabValue === 2 && <AgentResolvedLeadsListView  agentId={agentId} />
                }
                {
                    tabValue === 3 && <AgentSearchCriteriaListViewTile agentId={agentId}/>
                }
                {
                    tabValue === 4 && <AgentContactInfoView agentId={agentId}/>
                }
            </Paper>

        </Box>
    )

}

export default AdminAgentDashboard;
